
import { Component, Prop, Vue } from "vue-property-decorator";
import Restaurant from "@/domain/restaurant/Restaurant";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
@Component({
  components: { ConfirmationDialog }
})
export default class AppBar extends Vue {
  drawer = false;

  @Prop({ default: true })
  showAppBar!: boolean;

  showLogo = true;

  get confirmationDialog() {
    return this.$refs.confirmationDialog as ConfirmationDialog;
  }

  toggleLogo() {
    console.log("toggle logo");
    this.showLogo = !this.showLogo;
  }

  get selectedRestaurantName() {
    const rest = this.selectedRestaurant;
    if (rest == null) return this.$t("user.selectedRestaurant.none");
    return rest.restaurantName;
  }

  get hasSelectedRestaurant() {
    return this.selectedRestaurant != null;
  }

  get selectedRestaurant(): Restaurant | null {
    return this.$store.getters.getSelectedRestaurant;
  }

  get loading() {
    return this.$store.getters.getLoading;
  }

  set selectedRestaurant(newVal: Restaurant | null) {
    this.$store.dispatch("selectedRestaurant", newVal);
  }

  get restaurantList(): Restaurant[] {
    return this.$store.getters.getRestaurantList;
  }

  get multipleRestaurants() {
    return this.restaurantList.length > 1;
  }

  get noRestaurants() {
    return this.restaurantList.length === 0;
  }

  async doLogout() {
    if (
      await this.confirmationDialog.open(
        this.$tc("logout.message"),
        this.$tc("logout.confirmation")
      )
    ) {
      await this.$store.dispatch("logout");
    }
  }

  selectRestaurant(newRestaurant: Restaurant) {
    this.$store.dispatch("selectedRestaurant", newRestaurant);
  }

  get logoWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return 150;
      case "sm":
        return 150;
      case "md":
        return 150;
      case "lg":
        return 200;
      case "xl":
        return 200;
    }
  }
}
